module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LQ2bh9/images/cover.jpg?1696786155695",
      "alt": "This image is the cover for the book Wicked Kernersville, Wicked"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wicked Kernersville, Wicked\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The central Piedmont North Carolina town of Kernersville is known today for its quiet neighborhoods and lovely historic district homes. Few of its citizens would suspect that in earlier times the town had its fair share of unsavory characters. Wicked Kernersville lifts the veil from this little-known facet of the town�s past and introduces the reader to incidents that prompted one early resident to lament that it was unsafe to walk the streets. Using material gleaned from old newspapers and other sources, longtime residents Michael Marshall and Jerry Taylor bring these stories to life, giving the reader a glimpse of the town�s history unavailable from other sources.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael L. Marshall, Jerry L. Taylor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael Marshall is the VP of the Kernersville Historic Preservation Society (KHPS) and a member of the  Forsyth County Historical Association (FCHA) as well as Old Salem/Museum of Southern Decorative Arts. Jerry L. Taylor is on the board of directors of the KHPS and is also a member of FCHA. Jerry co-edited �Kernersville High School Remembered: 1927-1962,� published by the Kernersville Alumni Association, and he helped edit and prepare all text and graphics for �A Winner�s Life,� also published by the Kernersville Alumni Association. Together, they have authored short pieces for the KHPS, and their research has been the subject of several articles in the Greensboro News - Record.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0